import axios from 'axios'
import React, { Fragment } from 'react'

import { useState } from 'react'
import { Row, Button, Col, Modal, Container } from 'react-bootstrap'
import { useSelector } from 'react-redux'





const Acciones = ({handleClose}) => {

  const [show, setShow] = useState(false)
  const data_cambiarGestion = useSelector((state) => state.cambiarGestionReducer)
  const { cfg_form13 } = data_cambiarGestion
 
  return (
    <>
      <style type='text/css'>
        {`
  
    .btn-cambiar {
      background-color: #C14B49;
      color: #FFFFFF;
      width: 140px;
      padding:6px 0px 6px 0px;

    }
    .btn-cambiar:hover{
        background-color: #F6897E;
      color: #FFFFFF;
    }
    
    `}
      </style>
     
      <Container>
      <Row>
        <Col className='d-flex align-items-end justify-content-end m-2'>
          <Button className='m-2 w-auto' variant='outline-info'   onClick={handleClose} >
          {cfg_form13 && cfg_form13.cfg_form13["cambiotipogestion-btn-cerrar"]}
          </Button>
          <Button className='m-2 ' variant='cambiar' type="onSubmit">
          {cfg_form13 && cfg_form13.cfg_form13["cambiotipogestion-btn-aplicacambio"]}
          </Button>
          
        </Col>
      </Row>
      </Container>
    </>
  )
}

export default Acciones
